import Vue from 'vue';
import VueI18n from 'vue-i18n';
import merge from 'lodash.merge';

import language from './language';
import AREACODE from './lang_areacode'; // 地区本地语种同步
// element 语言包
import enLocale from 'irm-ui/lib/locale/lang/en';
import zhLocale from 'irm-ui/lib/locale/lang/zh-CN';
import twLocale from 'irm-ui/lib/locale/lang/zh-TW';

Vue.use(VueI18n);

export const EN = 'en';
export const ZH = 'zh-cn';
export const ZH_HK = 'zh-hk';
export const LANGUAGE_LIST = [ZH, EN, ZH_HK];

export const defaultLanguage = ZH;

const CN_MSG = {
	...language[ZH],
	...merge(zhLocale, {
		'el': {
			'pagination': {
				'total': '共 {total} 条',
				'pagesize': '条/页',
				'goto': '前往',
				'pageClassifier': '页'
			}
		}
	})
};
const EN_MSG = {
	...language[EN],
	...AREACODE.en,
	...merge(enLocale, {
		'el': {
			'pagination': {
				'total': 'A total of {total} ',
				'pagesize': '',
				'goto': 'Redirect',
				'pageClassifier': 'Pages'
			}
		}
	})
};
const HK_MSG = {
	...language[ZH_HK],
	...merge(twLocale, {
		'el': {
			'pagination': {
				'total': '共 {total} 條',
				'pagesize': '條/頁',
				'goto': '前往',
				'pageClassifier': '頁'
			}
		}
	})
};

const i18n = new VueI18n({
	locale: defaultLanguage,
	fallbackLocale: defaultLanguage,
	messages: {
		[ZH]: CN_MSG,
		[EN]: EN_MSG,
		[ZH_HK]: HK_MSG
	},
	silentTranslationWarn: true
});
i18n.EN = EN;
i18n.ZH = ZH;
i18n.ZH_HK = ZH_HK;

export function changeLocaleLang(lang) {
	const language =
		lang ||
		(/lang=([a-z_-]+[^&])/i.test(location.search) && RegExp.$1) ||
		window.sessionStorage.getItem('Language') ||
		navigator.language ||
		defaultLanguage;

	const langMap = { 'zh-cn': ZH, 'zh-hk': ZH_HK, 'en': EN };
	const locale = langMap[language.toLowerCase()] || defaultLanguage;
	i18n.locale = locale;

	if (lang) {
		window.sessionStorage.setItem('Language', locale);
	}
}

changeLocaleLang();

export const languageTypeMap = {
	[ZH]: 0,
	[ZH_HK]: 2,
	[EN]: 1
};
export const getLanguageType = () => languageTypeMap[i18n.locale];

export const languageMap = {
	0: ZH,
	1: EN,
	2: ZH_HK
};
export const getLanguageByType = type => languageMap[type];

export const translate = key => {
	// 使用 te 方法检查是否能够匹配到对应键值
	const locale = i18n.locale;
	const hasKey = i18n.te(key, locale);
	const translatedStr = i18n.t(key);
	if (hasKey) {
		return translatedStr;
	}
	return key;
};

export default i18n;
